import { useEffect, useState } from "react";
import { getMenuData } from "../utils/shared/getMenuData";

const useMenuData = (completeLiveEvents) => {
    const [sportsData, setSportsData] = useState([]);
    const [leaguesData, setLeaguesData] = useState([]);
    const [partnersData, setPartnersData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!completeLiveEvents || completeLiveEvents.length === 0) return;
        if (sportsData.length && leaguesData.length && partnersData.length) return;

        const fetchMenuData = async () => {
            setLoading(true);
            try {
                const data = await getMenuData(completeLiveEvents);
                setSportsData(data.sports || []);
                setLeaguesData(data.shortcuts || []);
                setPartnersData(data.partnerShortcuts || []);
            } catch (error) {
                console.error("Error fetching menu data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMenuData();
    }, [completeLiveEvents]);

    // Preload league images
    useEffect(() => {
        if (!leaguesData || leaguesData.length === 0) return;

        const images = [];
        leaguesData.forEach((league) => {
            if (league.logo) {
                const img = new window.Image();
                img.src = league.logo;
                images.push(img);
            }
        });
    }, [leaguesData]);

    return {
        sportsData,
        leaguesData,
        partnersData,
        loading,
    };
};

export default useMenuData;
